import { useNavigate } from "react-router-dom";
import { auth, provider } from "../../../firebase";
import { signOut,signInWithPopup, getRedirectResult } from "firebase/auth";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { LiaCrossSolid } from "react-icons/lia";

function Login() {

  let adminUsers = process.env.REACT_APP_ADMIN_USERS

  const navigate = useNavigate();

  const login = async () => {
    provider.setCustomParameters({ prompt: "select_account" });
    await signOut(auth); 
    try {
      let result  = await signInWithPopup(auth, provider);
      if (!result) return;
      const user = result.user;
      if (adminUsers.includes(user?.email)) {
        navigate("/dashboard");
        toast.success("Logged In Successfully!")
      } else {
        toast.error("You are not allowed to login to the application");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getRedirectResult(auth).then((result) => {
      if (!result) return;

      const user = result.user;

      if (adminUsers.includes(user?.email)) {
        navigate("/dashboard");
        toast.success("Logged In Successfully!")
      } else {
        toast.error("You are not allowed to login to the application");
      }
    });
  }, []);

  return (
   <div className="min-h-screen bg-[#7b026b] flex items-center justify-center px-4">
    <LiaCrossSolid className=" text-[50vw] md:text-[10vw] opacity-60 absolute top-[20%] text-white z-0" />
  <div className="w-full max-w-sm bg-white z-10  p-8">
    
    <h1 className="text-2xl font-bold text-gray-800 text-center mb-6">
      Admin Login
    </h1>

    <button
      onClick={login}
      className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg py-1 transition-all shadow-sm"
    >
      <img 
        src="https://www.svgrepo.com/show/475656/google-color.svg" 
        alt="Google Logo" 
        className="w-5  h-5"
      />
      <h6 className="text-gray-700 mt-2 font-[800]">Sign in with Google</h6>
    </button>

    <p className="text-center text-xs text-gray-500 mt-4">
      Access restricted to authorized users only
    </p>
  </div>
</div>

  );
}

export default Login;
